import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LoaderService, NavigateService} from 'ngx-satoris';
import {
  CurrencySign,
  Request,
  RequestRemoteState,
  RequestState, RequestSubState, RequestType,
} from '../../../shared/models/request';
import {ApiService} from '../../../shared/services/api.service';
import {Person} from '../../../shared/models/person';
import {formatDate} from 'src/app/shared/utils/string';
import {PlatformEventType} from '../../../shared/models/information';
import {environment} from 'src/environments/environment';
import {Document, DocumentType} from 'src/app/shared/models/user';
import {QrService} from 'src/app/shared/services/qr.service';
import {CartService, FormApplication} from '../../../shared/services/cart.service';
import {FormField, FormStep, VisaFN, VisaFormConfig, VisaFormName} from '../../../shared/models/forms';
import {format} from 'date-fns';
import {Visa} from '../../../shared/models/local-form';
import {flattenObject} from '../../../shared/utils/flattenObject';
import {RequestService} from '../../../shared/services/request.service';

@Component({
  selector: 'app-request-account',
  templateUrl: './request-account.component.html',
  styleUrls: ['./request-account.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RequestAccountComponent implements OnInit {
  RequestRemoteState = RequestRemoteState;
  currentRequest: Request;
  RequestState = RequestState;
  dataActualDocument: any;
  actualPerson: Person;
  PlatformEventType = PlatformEventType;
  formatDate = formatDate;
  paymentId: string;

  constructor(public nav: NavigateService,
    public qr : QrService,
    public cart: CartService,
    public api: ApiService,
    public request: RequestService,
    private route: ActivatedRoute,
    private loader: LoaderService) {
    this.paymentId = this.route.snapshot.paramMap.get('paymentId');
  }

  ngOnInit() {
    this.currentRequest = this.api.allMyPayments?.find((request: Request) => request.id === this.paymentId);
    if(!this.currentRequest) return this.nav.to('trips');
    if(this.currentRequest) {
      if(typeof this.currentRequest.serialized === 'string' && this.currentRequest.serialized && this.currentRequest.id) {
        this.loader.loading(true);
        this.currentRequest.serialized = this.api.getMetadataPayment(this.currentRequest.serialized, this.currentRequest.id).then((res: any) => {
          this.currentRequest.serialized = res;
          this.getExtensionsMetadata();
          return res;
        }).catch(() => {
          this.getExtensionsMetadata();
          return this.currentRequest.serialized;
        });
      }
    } else {
      this.nav.to('trips');
    }

    this.qr.qrOfflineGenerate((this.api.userRole.isAdmin || this.api.userRole.isWorker) ? this.api.userPlaceId : this.currentRequest.created_place_id, this.currentRequest.id, this.currentRequest.externalId);
    this.qr.setCurrentQrData(undefined, this.currentRequest);
  }

  getName(): string {
    const firtname = this.currentRequest?.internalIndexedData?.split('|')[0];
    const lastname = this.currentRequest?.internalIndexedData?.split('|')[1];
    return firtname + ' ' + lastname;
  }

  startCorrection(request: Request = this.currentRequest) {
    this.loader.loading(true);
    if(!request.refusalRefusedFields?.length || !request.serialized) return;
    const revisionVisaFormConfig: VisaFormConfig = JSON.parse(JSON.stringify(this.cart.getOriginalForm(request.operationId as DocumentType)));
    const meta = flattenObject(request.serialized as Visa);
    if(meta.NextOfKin) {
      meta.NextOfKin = JSON.parse(meta.NextOfKin);
      meta[VisaFN.EMERGENCY_LAST_NAME] = meta.NextOfKin.lastname;
      meta[VisaFN.EMERGENCY_FIRST_NAME] = meta.NextOfKin.firstname;
      meta[VisaFN.EMERGENCY_EMAIL] = meta.NextOfKin.email;
      meta[VisaFN.EMERGENCY_PHONE] = meta.NextOfKin.phone;
    }

    Object.keys(meta).forEach((key: any) => {
      Object.keys(revisionVisaFormConfig).forEach((step: string) => {
        const formStep: FormStep = revisionVisaFormConfig[step];
        formStep.errors = formStep.errors || [];
        const formField: FormField = formStep.fields?.find((field: FormField) => field.name === key);
        if(formField && !request.refusalRefusedFields.includes(key)) {
          const val: any = meta[key as keyof Visa];
          switch(formField.type) {
          case 'date':
            formField.value = format(new Date(val), 'yyyy-MM-dd');
            formField.disabled = true;
            break;
          case 'checkbox':
            formField.value = (val.toLowerCase() === 'true' || val.toLowerCase() === 'yes') ? val : '';
            formField.disabled = true;
            break;
          default:
            formField.value = val;
            formField.disabled = true;
            break;
          }
        } else if(formField && request.refusalRefusedFields.includes(key)) {
          formStep.errors.push({key: key, keyError: 'refused'});
          formStep.hasRevisionErrors = true;
        }
        formStep.visited = true;
        formStep.submitted = true;

        if(step === VisaFormName.REQUIREMENTS) {
          formStep.errors.push({key: 'refused', keyError: 'refused'});
          formStep.hasRevisionErrors = true;
        }

        if(step === VisaFormName.MISCELLANEOUS_DETAILS) {
          formStep.fields.find((field: FormField) => field.name === VisaFN.BATCH_ID).value = request.batchId;
        }
      });
    });

    if(request.refusalRefusedFields.includes(VisaFN.PURPOSE_OF_VISIT)) {
      revisionVisaFormConfig[VisaFormName.DOCUMENT].hasRevisionErrors = true;
      revisionVisaFormConfig[VisaFormName.DOCUMENT].fields.forEach((field: FormField) => {
        field.value = undefined;
        field.disabled = false;
        field.hidden = true;
      });
    }


    if(this.request.getField(VisaFormName.PERSONAL_DETAILS, VisaFN.PLACE_OF_BIRTH_COUNTRY, revisionVisaFormConfig) && !request.refusalRefusedFields.includes(VisaFN.PLACE_OF_BIRTH_CITY)) {
      this.request.getField(VisaFormName.PERSONAL_DETAILS, VisaFN.PLACE_OF_BIRTH_COUNTRY, revisionVisaFormConfig).value = meta.PlaceOfBirth.split(' - ')[0].trim();
      this.request.getField(VisaFormName.PERSONAL_DETAILS, VisaFN.PLACE_OF_BIRTH_CITY, revisionVisaFormConfig).value = meta.PlaceOfBirth.split(' - ')[1].trim();
      this.request.getField(VisaFormName.PERSONAL_DETAILS, VisaFN.PLACE_OF_BIRTH_COUNTRY, revisionVisaFormConfig).disabled = !request.refusalRefusedFields.includes(VisaFN.PLACE_OF_BIRTH_COUNTRY);
      this.request.getField(VisaFormName.PERSONAL_DETAILS, VisaFN.PLACE_OF_BIRTH_CITY, revisionVisaFormConfig).disabled = !request.refusalRefusedFields.includes(VisaFN.PLACE_OF_BIRTH_CITY);
    }
    if(this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_ZIM_ASK, revisionVisaFormConfig)) {
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_ZIM_ASK, revisionVisaFormConfig).value = meta.PreviousConvictionsZim ? 'true' : 'false';
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_ZIM, revisionVisaFormConfig).value = request.refusalRefusedFields.includes(VisaFN.PREVIOUS_CONVICTIONS_ZIM) ? '' : meta.PreviousConvictionsZim;
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_ZIM_ASK, revisionVisaFormConfig).disabled = !request.refusalRefusedFields.includes(VisaFN.PREVIOUS_CONVICTIONS_ZIM);
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_ZIM, revisionVisaFormConfig).disabled = !request.refusalRefusedFields.includes(VisaFN.PREVIOUS_CONVICTIONS_ZIM);
    }
    if(this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_HOME_ASK, revisionVisaFormConfig)) {
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_HOME_ASK, revisionVisaFormConfig).value = meta.PreviousConvictionsHome ? 'true' : 'false';
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_HOME, revisionVisaFormConfig).value = request.refusalRefusedFields.includes(VisaFN.PREVIOUS_CONVICTIONS_HOME) ? '' : meta.PreviousConvictionsHome;
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_HOME_ASK, revisionVisaFormConfig).disabled = !request.refusalRefusedFields.includes(VisaFN.PREVIOUS_CONVICTIONS_HOME);
      this.request.getField(VisaFormName.TRAVEL_INFORMATION, VisaFN.PREVIOUS_CONVICTIONS_HOME, revisionVisaFormConfig).disabled = !request.refusalRefusedFields.includes(VisaFN.PREVIOUS_CONVICTIONS_HOME);
    }

    const revisionApplication: FormApplication = {
      travelName: request.batchId,
      plannedEntry: meta.ProvisionnalEntryPort,
      requests: [
        {
          formConfig: revisionVisaFormConfig,
          nationality: (request.refusalRefusedFields as VisaFN[]).some(field => field === VisaFN.NATIONALITY) ? undefined : meta.Nationality,
          passportType: (request.refusalRefusedFields as VisaFN[]).some(field => field === VisaFN.PASSPORT_TYPE) ? undefined : meta.PassportType,
          visaType: (request.refusalRefusedFields as VisaFN[]).some(field => field === VisaFN.VISA_TYPE) ? undefined : this.api.userInfo.server.paymentRequests.find((doc: Document) => doc.id === request.operationId),
          urgent: meta.Urgent === 'Yes',
          person: {
            firstName: this.api.listPersons.find((person: Person) => person.id === request.person_id)?.firstName || '',
            lastName: this.api.listPersons.find((person: Person) => person.id === request.person_id)?.lastName || '',
            nationalNumber: '',
            batchIds: [],
            passportNumber: '',
            id: Number(request.person_id),
            linkType: null,
            otherLinkType: ''
          }
        }
      ],
      visaFeesAndTerms: false,
      isRevision: true,
      isExtend: request.operationId === DocumentType.ZWEVISAEXTC || request.operationId === DocumentType.ZWEVISAEXTAB,
      revisionFields: request.refusalRefusedFields as VisaFN[],
      requestId: request.id
    };

    this.loader.loading(true, {type: 'info', message: 'revision.start', btnLabel: 'yes', custom: {closeBtnLabel: 'no'}}).then((done ) => {
      if(done) {
        this.cart.startApplication(false, revisionApplication, revisionVisaFormConfig);
      }
    });
  }

  print() {
    window.print();
  }

  calculateDeadlineDate(usageAfter: string, millis: number): Date {
    const usageAfterDate = new Date(usageAfter);
    const deadlineDate = new Date(usageAfterDate.getTime() + millis);
    return deadlineDate;
  }

  getAmount(currency: keyof typeof CurrencySign, ammount: number, millis = true, showCurrency: boolean = true) : string{
    return (showCurrency && CurrencySign[currency]) + (millis ? ammount / 100 : ammount);
  }

  getExtensionsMetadata() {
    if(!this.currentRequest?.extensions?.length) {
      this.loader.loading(false);
      return;
    } else {
      this.currentRequest.extensions.map((request: Request) => this.api.getMetadataPayment(request?.serialized, request?.id).then((res: any) => {
        request.serialized = res;
        this.loader.loading(false);
        return request;
      }).catch(() => {
        this.loader.loading(false);
        return request;
      }));
    }
  }

  startContinue() {
    if(this.currentRequest && this.currentRequest.paymentType === RequestType.MNTA) {
      window.open('https://secure-payments.test.hobspay.com/confirm-transaction/'+this.currentRequest.externalId, '_self');
    } else {
      window.open('https://secure.pay.hobspay.com/confirm-transaction/'+this.currentRequest.externalId, '_self');
    }
  }

  protected readonly environment = environment;
  protected readonly DocumentType = DocumentType;
  protected readonly RequestSubState = RequestSubState;
}
